import { Component, ElementRef, EventEmitter, HostBinding, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DemandeEncadrementService } from '../../services/demande-encadrement/demande-encadrement.service';
import { AccountConfigService } from '../../services/account-config/account-config.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { MUser } from '@argalis-apps/models';
import { AuthService } from '../../../auth/services/auth/auth.service';

@Component({
  selector: 'ags-demandes-encadrement-details',
  templateUrl: './demandes-encadrement-details.component.html',
  styleUrls: ['./demandes-encadrement-details.component.scss']
})
export class DemandesEncadrementDetailsComponent implements OnInit {
  @HostBinding('class') themeFlag: string;
  public headerBackground = 'no-style-applied';
  public headerColor = 'no-style-applied';
  public demandeDetail: any = {};
  public isLoaded: boolean;
  public errorPage: boolean;
  private userConnected: MUser.CUser = null;
  public defaultPhoto = 'https://s3.eu-central-1.amazonaws.com/argalis-documents/document/image_def/avatar_default.png';
  public acceptURL: string;
  public refuseURL: string;

  @Input('header-background')
  set _headerBackground(uikitColor: string) {
    switch (uikitColor) {
      case 'muted':
        this.headerBackground = 'uk-background-muted';
        break;
      case 'primary':
        this.headerBackground = 'primary-background';
        break;
      case 'secondary':
        this.headerBackground = 'secondary-background';
        break;
      case 'primary-darker':
        this.headerBackground = 'primary-background-darker';
        break;
      case 'secondary-darker':
        this.headerBackground = 'secondary-background-darker';
        break;
      case 'primary-lighter':
        this.headerBackground = 'primary-background-lighter';
        break;
      case 'secondary-lighter':
        this.headerBackground = 'secondary-background-lighter';
        break;
      default:
        break;
    }
  }

  @Input('header-color')
  set _headerColor(color: string) {
    switch (color) {
      case 'primary':
        this.headerColor = 'primary-color';
        break;
      case 'secondary':
        this.headerColor = 'secondary-color';
        break;
      case 'alert':
        this.headerColor = 'alert-color';
        break;
      case 'basic':
        this.headerColor = 'basic-text';
        break;
      case 'colored':
        this.headerColor = 'colored-text';
        break;
      default:
        break;
    }
  }

  @Output() public demandesOutput = new EventEmitter<any[]>();

  constructor(
    private accountService: AccountConfigService,
    private demandeService: DemandeEncadrementService,
    private authService: AuthService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {
    this.themeFlag = `${this.themeFlag || ''} ${accountService.themingClassName}`;
    this.userConnected = this.authService.userConnected;
  }

  ngOnInit() {
    const idIntervenant = this.userConnected.userInfo.id;
    const idSession = this.activatedRoute.snapshot.paramMap.get('id') || 0;
    // on rafraichit le nombre de notification sur la sidebar à l'affichage
    this.demandeService.getListById(idIntervenant).subscribe((res: any) => {
      if (res) {
        this.demandesOutput.emit(res);
        const result = res[0];
        // on récupère les URL d'acceptation et de refus
        this.acceptURL = result.urlAccept;
        this.refuseURL = result.urlRefuse;
      }
    });
    // on récupère les détails de la demande à l'affichage
    this.demandeService.getDetailById(idIntervenant, idSession).subscribe(
      (res: any) => {
        this.isLoaded = true;
        if (!res) this.route.navigate(['/']);
        else this.demandeDetail = res;
        if (res && !(this.demandeDetail || {}).photoResponsible)
          this.demandeDetail.photoResponsible = this.defaultPhoto;
      },
      err => {
        this.isLoaded = true;
        this.errorPage = true;
        // this.getTestData(); // données de test
      }
    );
  }

  goBack() {
    this.location.back();
  }

  getTestData() {
    const sampleDemande = {
      id: 42,
      alreadyProcessed: false,
      dateCreation: '02/02/2019',
      dateValid: '11/12/2019', // date format dd/MM/YYYY
      remainingDay: ' Plus que 70 jours pour accepter cette proposition!',
      title: 'Calculs et fonctionnalités avancées sous Excel 2016',
      referenceProduit: 'PRT-00026',
      referenceSession: 'SES-170564',
      referenceInterne: 'Excel N2 Paris',
      modalite: 'Présentiel',
      duration: '2 jours du 11/12/2019 au 12/12/2019',
      dateBegin: '12/12/2019',
      dateEnd: '12/12/2019',
      lieuName: 'Novotel Paris-Les-Halles',
      lieuAddress: '8 place Marguerite de Navarre, 75001 Paris',
      nameResponsible: 'Hélène DURAND',
      emailResponsible: 'helene.durand@of.fr',
      phoneResponsible: '02 52 54 87 87',
      urlAccept:
        'https://back.argalis.fr/api/validationsession/intervenant/argalis_recette/1Vso41tt6oTK4YE-uTx9N-jZ/false/true',
      urlRefuse:
        'https://back.argalis.fr/api/validationsession/intervenant/argalis_recette/1Vso41tt6oTK4YE-uTx9N-jZ/false/false',
      planning: [
        {
          date: '11/12/2019',
          journee: 'matin',
          horaire: '09:00-12:00',
          site: 'Novotel Paris-Les-Halles - 8 place Marguerite de Navarre, 75001 Paris'
        },
        {
          date: '11/12/2019',
          journee: 'après-midi',
          horaire: '14:00-18:00',
          site: 'Novotel Paris-Les-Halles - 8 place Marguerite de Navarre, 75001 Paris'
        },
        {
          date: '12/12/2019',
          journee: 'matin',
          horaire: '09:00-12:00',
          site: 'Novotel Paris-Les-Halles - 8 place Marguerite de Navarre, 75001 Paris'
        },
        {
          date: '12/12/2019',
          journee: 'après-midi',
          horaire: '14:00-18:00',
          site: 'Novotel Paris-Les-Halles - 8 place Marguerite de Navarre, 75001 Paris'
        }
      ]
    };
    this.demandeDetail = sampleDemande;
  }

  refuse() {
    window.open(`${this.refuseURL}`);
    this.demandeDetail.alreadyProcessed = true;
  }

  accept() {
    window.open(`${this.acceptURL}`);
    this.demandeDetail.alreadyProcessed = true;
  }
}
